import { ListMenuItemProps } from "../../common/list/ListMenuItemProps";
import { isBoolean } from "lodash";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";
import { TripsViewListDto } from "../../../common/data/service-proxies";

interface Props extends ListMenuItemProps<TripsViewListDto> {}

export const ShowLocationHistoryMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const history = useHistory();

  if (!record?.vehicleId || !record?.date) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          history.push(
            `/${resourceNames.LOCATIONS_HISTORY}?date=${record.date}&vehicleId=${record.vehicleId}`
          );
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    </>
  );
};
